import { createContext, Dispatch, FormEvent, SetStateAction, useContext } from 'react';
import { GuideQueryParams } from './useFetchGuides';
import { Guide } from 'types/guide';

export interface GuideContextValue {
  anchorEl: HTMLButtonElement | null;
  setAnchorEl: Dispatch<SetStateAction<HTMLButtonElement | null>>;
  filter: GuideQueryParams;
  handleChange<K extends keyof GuideQueryParams>(index: K, value: GuideQueryParams[K]): void;
  handleSearch(e?: FormEvent<HTMLFormElement>): void;
  loading: boolean;
  selectedGuide: Guide | null;
  setSelectedGuide: Dispatch<SetStateAction<Guide | null>>;
  viewGuide: boolean;
  setViewGuide: Dispatch<SetStateAction<boolean>>;
  setCancelGuide: Dispatch<SetStateAction<boolean>>;
  setFinishGuide: Dispatch<SetStateAction<boolean>>;
  setNoShowGuide: Dispatch<SetStateAction<boolean>>;
}

const GuideContext = createContext<GuideContextValue>({} as GuideContextValue);
export const GuideProvider = GuideContext.Provider;
export const GuideConsumer = GuideContext.Consumer;

export function useGuide(): GuideContextValue {
  const context = useContext(GuideContext);
  return context;
}
